import { render, staticRenderFns } from "./OrthophotoLayerControls.vue?vue&type=template&id=63b3a9e8&scoped=true&"
import script from "./OrthophotoLayerControls.vue?vue&type=script&lang=js&"
export * from "./OrthophotoLayerControls.vue?vue&type=script&lang=js&"
import style0 from "./OrthophotoLayerControls.vue?vue&type=style&index=0&id=63b3a9e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b3a9e8",
  null
  
)

export default component.exports